"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("../constants");
/**
 * A client-side API caller builder, returning an GatewayCaller caller, whose major function is to attach gateway headers
 * to requests.
 *
 * Current underlying implementation HTTP library is Axios
 *
 * @param gateway a UUID that maps to the desired gateway (mapped in config)
 * @returns an GatewayCaller client-side API caller
 */
const usingGateway = (gateway) => {
    return {
        get: async (config) => {
            if (!config.url) {
                throw Error("Url was not provided to the gatewayCaller. Please provide url in the config.");
            }
            config.headers = { ...config.headers, [constants_1.X_GATEWAY_HEADER]: gateway };
            return axios_1.default.get(config.url, config);
        },
        post: async (config) => {
            if (!config.url) {
                throw Error("Url was not provided to the gatewayCaller. Please provide url in the config.");
            }
            config.headers = { ...config.headers, [constants_1.X_GATEWAY_HEADER]: gateway };
            return axios_1.default.post(config.url, config.data, config);
        },
    };
};
exports.default = usingGateway;
